import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import axios from '@/common/axios'


const information_obj = {
    namespaced: true,
 
    state: {
        informations: [],
        information: {},
        holding_info: {},
        register_link: {},
        lineContact: {},
    },
    mutations: {
        SET_INFORMATIONS (state, informations) {
            state.informations = informations
        },
        SET_HOLDING_INFO (state, holding_info) {
            state.holding_info = holding_info
        },
        SET_REGISTER_LINK (state, register_link) {
            state.register_link = register_link
        },
        SET_LINECONTACT_LINK (state, lineContact) {
            state.lineContact = lineContact
        },
    },
    actions: {
        // API Calls
        async getInfotmation ({ commit, rootGetters }) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']

                

                const response = await axios.get('information')
                commit('SET_INFORMATIONS', response.data)
            } catch (error) {
                throw new Error(error)
            }
        },

        async getHoldingInfo ({ commit, rootGetters }) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('holdinginfo')
                commit('SET_HOLDING_INFO', response.data)
                return response.data
                // console.log('getHoldingInfo: ', response)
                // commit('SET_HOLDING', response.data)
            } catch (error) {
                throw error
            }
        },

        async getResgisterLink ({ commit, rootGetters }) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('registerlink')
                commit('SET_REGISTER_LINK', response.data)
                return response.data
            } catch (error) {
                throw error
            }
        },

        async getLineContact ({ commit, rootGetters }) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('linecontact')

                let line_data = {
                    name: process.env.VUE_APP_LINE_NAME ? process.env.VUE_APP_LINE_NAME : process.env.VUE_APP_SITE,
                    link: process.env.VUE_APP_LINE_CONTACT
                }
                if ( response.data ) {
                    line_data.name = response.data.header ? response.data.header : line_data.name
                    line_data.link = response.data.body ? response.data.body : line_data.link
                }

                commit('SET_LINECONTACT_LINK', line_data)
                return line_data
            } catch (error) {
                throw error
            }
        },
       
    },
    getters: {
        getInformationCount: (state) => {
            return state.informations.length
        },
        getAnnouceRecord: (state) => {
            //return state.informations.filter(information => information.type_id == 1)
            return state.informations.find(information => information.type_id == 1)
        },
        getMarqueeText: (state) => {
            //return state.informations.filter(information => information.type_id == 1)
            return state.informations.find(information => information.type_id == 2)
        },
        holding_info: (state) => {
            return state.holding_info
        },
        register_link: (state) => {
            return state.register_link
        },
        lineContact: (state) => {
            return state.lineContact
        },
    }

}

export default information_obj
